import ScrollItem from './ScrollItem';
import VisionH2Webp from '../img/Vision-h2.webp';
import VisionH2 from '../img/Vision-h2.png';
import './Vision.css';
import './Glitch.css';

export default function Vision() {
    return (
        <section className="Vision" id="vision">
            {/* glitch background */}
            <div className="glitch">
                <div className="glitch__img img__02"></div>
                <div className="glitch__img img__02"></div>
                <div className="glitch__img img__02"></div>
                <div className="glitch__img img__02"></div>
                <div className="glitch__img img__02"></div>
            </div>

            <div className="Vision__container">
                <ScrollItem>
                    <h2 className="Vision__h2">
                        <div className="Vision__h2__img">
                            <picture>
                                <source type="image/webp" srcSet={VisionH2Webp} />
                                <img src={VisionH2} alt="Vision" />
                            </picture>
                        </div>
                    </h2>
                </ScrollItem>
                <div className="Vision__textContainer">
                    <ScrollItem>
                        <p className="Vision__topText">
                            The “BŌSŌ” brand is a statement from Tokyo,
                            here to ignite your identity in the metaverse.
                        </p>
                    </ScrollItem>
                    <ScrollItem>
                        <p className="Vision__text">From legend, TENJIN HIDETAKA,<br className="br--pc" />
                            comes 10000 one-of-a-kind pieces of art.</p>
                    </ScrollItem>
                    <ScrollItem>
                        <p className="Vision__text">They’re not just PFPs. They come with high-quality 3D avatars for
                            you to bring into<br className="br--pc" />
                            the metaverse.</p>
                    </ScrollItem>
                    <ScrollItem>
                        <p className="Vision__text">BŌSŌ is for those who believe and crave,<br className="br--pc" />
                            to buzz in this open world of limitless transformation.</p>
                    </ScrollItem>
                    <ScrollItem>
                        <p className="Vision__text"> If that’s you, let’s go. Let’s REV it up.<br className="br--pc" />
                            We’re bringing together the whole clan..<br className="br--pc" />
                            We’re creating a brand, community, opportunity, and future.<br />
                            A special team, bringing to the world what is made in Japan.</p>
                    </ScrollItem>
                    <ScrollItem>
                        <p className="Vision__text">The “BOSOZOKU 暴走族 ” wear “MATOI 纏”. Japanese characters that
                            represent<br className="br--pc" /> your “SHIN-NEN 信念”.<br />
                            What you are. What you believe. This, is your SHIN-NEN.<br />
                            “電上電下唯我独尊 Denjou Denge Yuigadokuson”<br className="br--pc" />
                            “Become the One and Only (In the Metaverse)”</p>
                    </ScrollItem>
                </div>
            </div>
        </section>
    )
}